import React from "react";

interface SidebarState {
    isOpen: boolean;
    toggleOpen: any;
}

export const SidebarStateContext = React.createContext<SidebarState>({isOpen: false, toggleOpen: () => {}});
